import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useViewerRoles } from '@treams/treams-hooks';
import { Button, Popover } from '@treams/treams-ui';

import { ConversationRevealUploadForm } from './ConversationRevealUploadForm';
import { PendingRevealUpload } from './useConversationRevealUpload';

interface IProps {
	evaluationFormID?: string;
	/** Deferred mode (create page): hand the upload back instead of saving. */
	onComplete?: (pending: PendingRevealUpload) => void;
}

export function ConversationRevealUploadButton({ evaluationFormID, onComplete }: IProps) {
	const { t } = useTranslation();
	const { isWorkspaceSuperuser } = useViewerRoles();
	const [open, setOpen] = useState(false);
	const [busy, setBusy] = useState(false);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const handleDismiss = () => {
		if (!busy) {
			setOpen(false);
		}
	};

	if (!isWorkspaceSuperuser) {
		return null;
	}

	return (
		<Popover.Target
			backdrop
			center
			visible={open}
			onDismiss={handleDismiss}
			contents={
				open ? (
					<ConversationRevealUploadForm
						evaluationFormID={evaluationFormID}
						onComplete={onComplete}
						onClose={handleClose}
						onBusyChange={setBusy}
					/>
				) : null
			}
		>
			<Button
				small
				type="secondary"
				title={t('conversations.reveal.upload.button')}
				onClick={handleOpen}
			/>
		</Popover.Target>
	);
}
